<span [ngClass]="isActive ? 'text-primary-600' : 'text-gray-300'" class="font-medium" [innerHtml]="chevronIcon | safeSvg"></span>
